import { IStore } from 'redux/root';

export const getLoaderState = (store: IStore): boolean => store.loader.show;
